// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 12.19.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// JS extensions and helpers for Bootstrap's Modal component
// -----------------------------------------------------------------------------
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const Modal = (($) => {
  const Selector = {
    MODAL: '.modal',
    BOLDCHAT: '.bcFloat, #bc-chat-container',
    QUIQ_CHAT: '.js--quiq-chat-btn, #quiqWebChat',
    DISPLAY_HIDDEN: 'd-none'
  }

  const Event = {
    SHOW: 'show.bs.modal',
    SHOWN: 'shown.bs.modal',
    HIDE: 'hide.bs.modal',
    HIDDEN: 'hidden.bs.modal'
  }

  // Prevent Quiq/Boldchat interference with active modals
  function initToggleChatBar () {
    // Add listeners on window.load to ensure they apply to dynamically
    // injected Modals (i.e. Leadfeeder)
    $(Selector.MODAL).on(Event.SHOW, () => {
      if (window.quiq) {
        $(Selector.QUIQ_CHAT).addClass(Selector.DISPLAY_HIDDEN)
      }

      if (window._bcvma) {
        $(Selector.BOLDCHAT).addClass(Selector.DISPLAY_HIDDEN)
      }
    })

    $(Selector.MODAL).on(Event.HIDDEN, () => {
      if (window.quiq) {
        $(Selector.QUIQ_CHAT).removeClass(Selector.DISPLAY_HIDDEN)
      }

      if (window._bcvma) {
        $(Selector.BOLDCHAT).removeClass(Selector.DISPLAY_HIDDEN)
      }
    })
  }

  function preventBackgroundContentScrolling () {
    const $body = $('body')
    const $html = $('html')
    const modals = document.getElementsByClassName('modal')
    const classes = 'prevent-scrolling ios-natural-scrolling'

    $body.on(Event.SHOWN, '.modal', () => {
      $html.addClass(classes)
      $body.addClass(classes)

      for (let modal of modals) {
        if (modal.classList.contains('show')) {
          disableBodyScroll(document.getElementById(modal.id))
        }
      }
    })

    $body.on(Event.HIDE, '.modal', () => {
      $html.removeClass(classes)
      $body.removeClass(classes)
      clearAllBodyScrollLocks()
    })
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let Modal = {
    init () {
      initToggleChatBar()
      preventBackgroundContentScrolling()
    }
  }

  return Modal
})(jQuery)

export default Modal
